import {Component, ContentChild, Input, OnInit, TemplateRef} from '@angular/core';
import {fadeIn} from "../../animations/basic-animation";
import {fadeSmooth} from "../../animations/router-animation";

@Component({
  selector: 'view-details-item',
  templateUrl: './view-details-item.component.html',
  styleUrls: ['./view-details-item.component.scss'],
  animations: [fadeIn, fadeSmooth]
})
export class ViewDetailsItemComponent implements OnInit {

  @Input() key: string;
  @Input() value: any;
  @Input() color = '';
  @Input() valueType: string | 'number' | 'html' | 'date';
  @Input() otherClasses: string;
  @Input() hasBorder: boolean = false;
  @ContentChild(TemplateRef, {static: true}) customView: TemplateRef<any>;

  constructor() {
  }

  ngOnInit(): void {
  }

}
